import * as React from 'react';
import { useEffect, useState } from 'react';
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from "react-icons/ai";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { GetSession, SetSession } from 'session-manager-beta';
import { setOpen } from '../../Redux/Services/headerSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { CommonApiData, } from '../CommonComponents/EnvConfig';

export const toggleFullScreen = (event, ID, setIsFullScreen, isFullScreen) => {
    if (!isFullScreen) {
        // Request full screen
        let element = document.documentElement;
        if (ID !== undefined && ID !== '') {
            element = document.getElementById(ID);
        }
        if (element) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
            element.style.overflow = 'auto';
            setIsFullScreen(true);
        }
    }
    else {
        // Exit full screen
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        document.body.style.overflow = 'auto';
        setIsFullScreen(false);
    }

};

const Header = () => {
    const dispatch = useDispatch()
    const open = useSelector((state) => state.header.open);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isDropdown, setIsDropdown] = useState(false)
    const user = GetSession('cookies', 'user');
    const navigate = useNavigate()
    const data = CommonApiData()
    const Logout = async () => {
        let user = GetSession('cookies', 'user')
        await SetSession('cookies', 'user', { ...user, loginSessionID: 'EXPIRED' })
        navigate('/');
    };
    useEffect(() => {
        document.body.classList.add('light');
    }, []);

    useEffect(() => {
        if (!user?.loginSessionID)
            NotificationSound('EXPIRED', 'EXPIRED')
    }, [user]);

    return (
        <>
            <nav className={`navbar navbar-expand-lg fixed-top navbar-light main-header p-0`}>
                <div className="container-fluid align-items-center ">
                    <img src={'./images/logo2.png'} className={`icon`} alt='Admin logo' />
                    <i onClick={() => dispatch(setOpen(!open))} className="fa-solid fa-bars mx-3"></i>
                    <ul className="navbar-nav ms-auto d-flex flex-row nav-side-icon align-items-center">
                        <li key='an' className="d-flex align-items-center">
                            <div
                                className="nav-item dropdown nav-link dropdown-toggle d-flex align-items-center"
                                role="button"
                                data-bs-toggle="dropdown"
                                onClick={() => setIsDropdown(!isDropdown)}
                                aria-expanded={isDropdown}
                            >
                                <div className='px-3 py-1'>
                                    <p className='m-0 fw-bold' style={{ fontSize: '13px', color: 'var(--text)' }}>
                                        <span className='green_dot'></span>
                                        {data?.UserName} [{data?.UserCode}]
                                    </p>
                                </div>
                                <img
                                    src='./images/user.svg'
                                    alt='user'
                                    style={{ width: '30px', height: '30px', borderRadius: '50%' }}
                                />
                            </div>
                            <ul className="dropdown-menu dropdown-menu-end p-0">
                                <li key='logout'>
                                    <button className="dropdown-item" style={{ fontSize: '13px', color: 'var(--text)' }} onClick={Logout}>Logout</button>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span
                                style={{
                                    color: 'var(--blue)',
                                    fontSize: '25px',
                                    cursor: 'pointer'
                                }}
                                title='Full Screen'
                                onClick={(event) => toggleFullScreen(event, '', setIsFullScreen, isFullScreen)}
                            >
                                {!isFullScreen ? <AiOutlineFullscreen /> : <AiOutlineFullscreenExit />}
                            </span>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    )
}
export default Header;